import { render, staticRenderFns } from "./TurmasCard.vue?vue&type=template&id=30309d8d&scoped=true"
import script from "./TurmasCard.vue?vue&type=script&lang=js"
export * from "./TurmasCard.vue?vue&type=script&lang=js"
import style0 from "./TurmasCard.vue?vue&type=style&index=0&id=30309d8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30309d8d",
  null
  
)

export default component.exports